import React, { useState, ReactNode } from 'react';

interface CollapsibleSectionProps {
  title: string;
  children: ReactNode;
  defaultCollapsed?: boolean;
  headerActions?: ReactNode;
  className?: string;
}

/**
 * Reusable collapsible section component
 */
export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  children,
  defaultCollapsed = false,
  headerActions,
  className = ''
}) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  const toggleCollapsed = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <section className={`collapsible-section ${isCollapsed ? 'collapsed' : ''} ${className}`}>
      <h2 
        className="collapsible-header" 
        onClick={toggleCollapsed}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleCollapsed();
          }
        }}
      >
        <span className="section-title">{title}</span>
        {headerActions && (
          <div 
            className="header-actions"
            onClick={(e) => e.stopPropagation()} // Prevent collapse when clicking actions
          >
            {headerActions}
          </div>
        )}
      </h2>
      
      <div className="collapsible-content">
        {children}
      </div>
    </section>
  );
};
